<template>
  <v-dialog
    ref="dialog"
    v-model="modal"
    :return-value.sync="date"
    persistent
    width="290px"
  >
    <template v-slot:activator="{ on, attrs }">
      <v-text-field
        v-model="formattedDate"
        :label="$attrs.label"
        readonly
        v-bind="attrs"
        :dense="$attrs.dense"
        v-on="on"
        outlined
        prepend-inner-icon="mdi-calendar"
        :errorMessages="$attrs.errorMessages"
      ></v-text-field>
    </template>
    <v-date-picker v-model="date" v-bind="$attrs" scrollable>
      <v-spacer></v-spacer>
      <v-btn text color="primary" @click="modal = false">
        Cancel
      </v-btn>
      <v-btn text color="primary" @click="updateDate">
        OK
      </v-btn>
    </v-date-picker>
  </v-dialog>
</template>
<script>
import dayjs from "dayjs";

export default {
  data: () => ({
    date: "",
    // new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
    //   .toISOString()
    //   .substr(0, 10),
    modal: false,
    formattedDate: "",
  }),
  props: {
    value: [String],
    initialVal: {
      type: String,
      default: "",
    },
    initalDate: {
      type: String,
      default: "",
    },
    isEighteenBack: {
      type: Boolean,
      default: false,
    },
  },
  mounted() {
    this.setDatePicker();
  },
  methods: {
    setDatePicker() {
      // let initialVal = this.value || undefined;
      if (this.initialVal) {
        this.date = dayjs(this.initialVal).format("YYYY-MM-DD");
        this.formattedDate = dayjs(this.initialVal).format("DD-MM-YYYY");
      }
      if (this.initalDate) {
        this.date = this.initalDate;
      }
      if (this.value) {
        this.date = dayjs(this.value).format("YYYY-MM-DD");
        this.formattedDate = dayjs(this.value).format("DD-MM-YYYY");
      }
    },
    updateDate() {
      this.formattedDate = dayjs(this.date).format("DD-MM-YYYY");
      this.$emit("input", this.date);
      this.$refs.dialog.save(this.date);
    },
  },
};
</script>
